import { useEffect, useMemo, useState } from "react";

function fmt(n) { return Number(n).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "€"; }
function fmtDate(ts) { return new Date(ts).toLocaleString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); }

// ── Popup vaciar (general o por miembro) ─────────────────────────────────────
function PopupVaciar({ caja, onClose, onDone }) {
  const isMulti = caja.members?.length > 1;

  // Estado inicial: todos seleccionados con su importe
  const initMembers = () => (caja.byUser || []).map(u => ({
    userId: u.userId,
    label: u.cajaLabel || u.displayName,
    uniqueId: u.lastKnownUniqueId,
    amount: u.amount,
    count: u.count,
    selected: u.amount > 0,
  }));

  const [members, setMembers] = useState(initMembers);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const toggleMember = (userId) => setMembers(prev => prev.map(m => m.userId === userId ? { ...m, selected: !m.selected } : m));
  const setAmount = (userId, val) => setMembers(prev => prev.map(m => m.userId === userId ? { ...m, amount: val } : m));

  const selected = members.filter(m => m.selected && m.count > 0);
  const total = selected.reduce((s, m) => s + (Number(m.amount) || 0), 0);
  const allSelected = isMulti && selected.length === members.filter(m => m.count > 0).length;

  const confirm = async () => {
    setSaving(true); setErr("");
    try {
      const body = isMulti
        ? { members: selected.map(m => ({ userId: m.userId, amount: Number(m.amount) || 0 })) }
        : { members: [] }; // vaciar todo (global)

      const res = await fetch(`/api/cajas/${caja.caja}/vaciar`, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
      onDone();
    } catch (e) { setErr(String(e.message || e)); }
    finally { setSaving(false); }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
      onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 16, padding: 24, maxWidth: 460, width: "100%", boxShadow: "0 12px 40px rgba(0,0,0,0.2)", maxHeight: "90vh", overflow: "auto" }}
        onClick={e => e.stopPropagation()}>

        <div style={{ fontWeight: 800, fontSize: 17, marginBottom: 4 }}>💳 Liquidar caja {caja.caja}</div>
        <div style={{ fontSize: 13, opacity: 0.55, marginBottom: 18 }}>
          {isMulti ? "Selecciona quién ha pagado y ajusta el importe si es necesario" : "Confirma el importe a cobrar"}
        </div>

        {/* Filas por comprador */}
        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 18 }}>
          {members.map(m => (
            <div key={m.userId} style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", border: `2px solid ${m.selected && m.count > 0 ? "var(--brand-red)" : "#e5e7eb"}`, borderRadius: 12, background: m.selected && m.count > 0 ? "#fff8f8" : "#fafafa", opacity: m.count === 0 ? 0.45 : 1 }}>
              {isMulti && (
                <input type="checkbox" checked={m.selected && m.count > 0} disabled={m.count === 0}
                  onChange={() => toggleMember(m.userId)}
                  style={{ width: 18, height: 18, accentColor: "var(--brand-red)", flexShrink: 0 }} />
              )}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 14 }}>{m.label}</div>
                <div style={{ fontSize: 11, opacity: 0.5 }}>@{m.uniqueId} · {m.count} compra{m.count !== 1 ? "s" : ""}
                  {m.count === 0 && " · ya liquidado"}
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <input
                  type="number" min="0" step="0.01"
                  value={m.amount}
                  onChange={e => setAmount(m.userId, e.target.value)}
                  disabled={!m.selected || m.count === 0}
                  style={{ width: 90, padding: "6px 8px", border: "1px solid #ddd", borderRadius: 8, fontSize: 14, fontWeight: 700, textAlign: "right", background: "white" }}
                />
                <span style={{ fontSize: 13, opacity: 0.6 }}>€</span>
              </div>
            </div>
          ))}
        </div>

        {/* Total */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 16px", background: "#fff7ed", borderRadius: 12, marginBottom: 20, border: "1px solid #fed7aa" }}>
          <div>
            <div style={{ fontSize: 12, opacity: 0.6 }}>Total a cobrar</div>
            {isMulti && <div style={{ fontSize: 11, opacity: 0.5 }}>{selected.length} de {members.length} compradores</div>}
          </div>
          <div style={{ fontWeight: 900, fontSize: 26, color: "#c2410c" }}>{fmt(total)}</div>
        </div>

        {err && <div style={{ color: "crimson", fontSize: 13, marginBottom: 12, padding: "8px 12px", background: "#fff1f2", borderRadius: 8 }}>{err}</div>}

        <div style={{ display: "flex", gap: 10 }}>
          <button className="btn btn-outline" style={{ flex: 1 }} onClick={onClose} disabled={saving}>Cancelar</button>
          <button className="btn btn-primary" style={{ flex: 1 }} onClick={confirm}
            disabled={saving || selected.length === 0 || total <= 0}>
            {saving ? "Guardando…" : isMulti && !allSelected ? `✓ Liquidar selección (${fmt(total)})` : `✓ Liquidar todo (${fmt(total)})`}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Popup ajuste manual ───────────────────────────────────────────────────────
function PopupAjuste({ caja, onClose, onDone }) {
  const isMulti = caja.members?.length > 1;
  const [userId, setUserId] = useState("");
  const [mode, setMode] = useState("ajuste"); // "ajuste" | "fijar"
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const currentBalance = userId
    ? (caja.byUser?.find(u => u.userId === userId)?.amount ?? 0)
    : caja.totalAmount;

  // En modo "fijar": el ajuste real = currentBalance - targetTotal
  const computedAmt = mode === "fijar"
    ? (Number(amount) !== "" && amount !== "" ? currentBalance - Number(amount) : null)
    : (amount !== "" ? Number(amount) : null);

  const previewBalance = computedAmt != null
    ? Math.max(0, currentBalance - computedAmt)
    : null;

  const confirm = async () => {
    if (computedAmt == null || computedAmt === 0) { setErr("El importe no puede resultar en 0"); return; }
    setSaving(true); setErr("");
    try {
      const defaultNote = mode === "fijar"
        ? `Fijar total a ${Number(amount).toFixed(2)} €`
        : "Ajuste manual";
      const body = { amount: computedAmt, note: note || defaultNote, ...(userId ? { userId } : {}) };
      const res = await fetch(`/api/cajas/${caja.caja}/ajuste`, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
      onDone();
    } catch (e) { setErr(String(e.message || e)); }
    finally { setSaving(false); }
  };

  const btnStyle = (m) => ({
    flex: 1, padding: "7px 0", fontSize: 13, fontWeight: 700, borderRadius: 8, cursor: "pointer",
    border: mode === m ? "2px solid #c0392b" : "2px solid #ddd",
    background: mode === m ? "#c0392b" : "#fff",
    color: mode === m ? "#fff" : "#555",
  });

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
      onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 16, padding: 24, maxWidth: 420, width: "100%", boxShadow: "0 12px 40px rgba(0,0,0,0.2)" }}
        onClick={e => e.stopPropagation()}>

        <div style={{ fontWeight: 800, fontSize: 17, marginBottom: 16 }}>⚙️ Ajuste — Caja {caja.caja}</div>

        {/* Modo toggle */}
        <div style={{ display: "flex", gap: 8, marginBottom: 18 }}>
          <button style={btnStyle("ajuste")} onClick={() => { setMode("ajuste"); setAmount(""); }}>± Sumar / Restar</button>
          <button style={btnStyle("fijar")} onClick={() => { setMode("fijar"); setAmount(""); }}>= Fijar total</button>
        </div>

        {isMulti && (
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12, fontWeight: 700, opacity: 0.6, display: "block", marginBottom: 6 }}>Aplicar a</label>
            <select value={userId} onChange={e => setUserId(e.target.value)}
              style={{ width: "100%", padding: "9px 12px", border: "1px solid #ddd", borderRadius: 10, fontSize: 14 }}>
              <option value="">Toda la caja</option>
              {caja.members.map(m => (
                <option key={m.id} value={m.id}>{m.cajaLabel || m.displayName} (@{m.lastKnownUniqueId})</option>
              ))}
            </select>
          </div>
        )}

        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 12, fontWeight: 700, opacity: 0.6, display: "block", marginBottom: 6 }}>
            {mode === "fijar" ? "Total deseado (€)" : "Importe (€) — positivo quita, negativo añade"}
          </label>
          <input type="number" step="0.01" min="0" value={amount} onChange={e => setAmount(e.target.value)}
            placeholder={mode === "fijar" ? "ej: 120.00  (nuevo total)" : "ej: 45.50  (positivo = quitar saldo)"}
            style={{ width: "100%", padding: "9px 12px", border: "1px solid #ddd", borderRadius: 10, fontSize: 14, boxSizing: "border-box" }} />

          <div style={{ fontSize: 12, marginTop: 6, display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
            <span style={{ opacity: 0.55 }}>Saldo actual: <strong>{fmt(currentBalance)}</strong></span>
            {previewBalance != null && (
              <span style={{ fontWeight: 700, color: previewBalance < currentBalance ? "#15803d" : "#dc2626" }}>
                → quedará: {fmt(previewBalance)}
              </span>
            )}
          </div>
        </div>

        <div style={{ marginBottom: 18 }}>
          <label style={{ fontSize: 12, fontWeight: 700, opacity: 0.6, display: "block", marginBottom: 6 }}>Motivo (opcional)</label>
          <input value={note} onChange={e => setNote(e.target.value)}
            placeholder="ej: Pago en efectivo, corrección histórica…"
            style={{ width: "100%", padding: "9px 12px", border: "1px solid #ddd", borderRadius: 10, fontSize: 14, boxSizing: "border-box" }} />
        </div>

        {err && <div style={{ color: "crimson", fontSize: 13, marginBottom: 12, padding: "8px 12px", background: "#fff1f2", borderRadius: 8 }}>{err}</div>}

        <div style={{ display: "flex", gap: 10 }}>
          <button className="btn btn-outline" style={{ flex: 1 }} onClick={onClose} disabled={saving}>Cancelar</button>
          <button className="btn btn-primary" style={{ flex: 1 }} onClick={confirm} disabled={saving || amount === ""}>
            {saving ? "Guardando…" : mode === "fijar" ? `Fijar total a ${fmt(Number(amount) || 0)}` : "Aplicar ajuste"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Historial vaciados ────────────────────────────────────────────────────────
function HistorialVaciados({ caja, onClose }) {
  const [vaciados, setVaciados] = useState([]);
  const [ajustes,  setAjustes]  = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [expandIdx, setExpandIdx] = useState(null);

  useEffect(() => {
    Promise.all([
      fetch(`/api/cajas/${caja}/vaciados`).then(r => r.json()),
      fetch(`/api/cajas/${caja}/ajustes`).then(r => r.json()),
    ]).then(([v, a]) => { setVaciados(v); setAjustes(a); }).finally(() => setLoading(false));
  }, [caja]);

  // Entrelazar vaciados y ajustes por fecha
  const events = useMemo(() => {
    const all = [
      ...vaciados.map(v => ({ ...v, _type: "vaciado" })),
      ...ajustes.map(a => ({ ...a, _type: "ajuste" })),
    ];
    return all.sort((a, b) => b.createdAt - a.createdAt);
  }, [vaciados, ajustes]);

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 100 }}
      onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 14, padding: 28, maxWidth: 560, width: "90%", maxHeight: "80vh", overflow: "auto", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" }}
        onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <div>
            <h3 style={{ margin: 0 }}>Historial — Caja {caja}</h3>
            <div style={{ fontSize: 12, opacity: 0.5, marginTop: 2 }}>{events.length} evento{events.length !== 1 ? "s" : ""}</div>
          </div>
          <button className="btn btn-outline" onClick={onClose}>Cerrar</button>
        </div>

        {loading ? <p>Cargando…</p> : events.length === 0 ? (
          <p style={{ opacity: 0.6 }}>Sin historial para esta caja.</p>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {events.map((ev, i) => ev._type === "ajuste" ? (
              <div key={`a${ev.id}`} style={{ border: "1px solid #e0e7ff", borderRadius: 10, padding: "12px 14px", background: "#f5f3ff" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 13 }}>⚙️ Ajuste manual — {fmtDate(ev.createdAt)}</div>
                    <div style={{ fontSize: 12, opacity: 0.6, marginTop: 2 }}>{ev.note || "Sin nota"}</div>
                  </div>
                  <div style={{ fontWeight: 800, fontSize: 15, color: ev.amount > 0 ? "#15803d" : "#dc2626" }}>
                    {ev.amount > 0 ? "-" : "+"}{fmt(Math.abs(ev.amount))}
                  </div>
                </div>
              </div>
            ) : (
              <div key={`v${ev.id}`} style={{ border: "1px solid #e5e7eb", borderRadius: 10, overflow: "hidden" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 14px", cursor: ev.breakdown?.length > 1 ? "pointer" : "default", background: "#fafafa" }}
                  onClick={() => ev.breakdown?.length > 1 && setExpandIdx(expandIdx === i ? null : i)}>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 13 }}>
                      💳 {ev.userId ? "Liquidación parcial" : "Liquidación completa"} — {fmtDate(ev.createdAt)}
                    </div>
                    <div style={{ fontSize: 12, opacity: 0.55 }}>
                      {ev.count} compra{ev.count !== 1 ? "s" : ""}
                      {ev.breakdown?.length > 1 && <span style={{ color: "var(--brand-red)", marginLeft: 6 }}>{expandIdx === i ? "▲" : "▼"} desglose</span>}
                    </div>
                  </div>
                  <div style={{ fontWeight: 800, fontSize: 16, color: "var(--brand-red)" }}>{fmt(ev.totalAmount)}</div>
                </div>
                {expandIdx === i && ev.breakdown?.length > 0 && (
                  <div style={{ borderTop: "1px solid #f3f4f6" }}>
                    {ev.breakdown.map(b => (
                      <div key={b.userId} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "9px 14px", borderBottom: "1px solid #f9fafb" }}>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: 13 }}>{b.label}</div>
                          <div style={{ fontSize: 11, opacity: 0.5 }}>@{b.uniqueId} · {b.count} compra{b.count !== 1 ? "s" : ""}</div>
                        </div>
                        <div style={{ fontWeight: 700, fontSize: 14 }}>{fmt(b.amount)}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function SortTh({ label, col, sort, onSort }) {
  const active = sort.col === col;
  return (
    <th style={{ ...th, cursor: "pointer", userSelect: "none", color: active ? "var(--brand-red)" : "inherit" }} onClick={() => onSort(col)}>
      {label}<span style={{ opacity: active ? 1 : 0.3, fontSize: 11 }}>{active ? (sort.dir === "asc" ? " ▲" : " ▼") : " ⇅"}</span>
    </th>
  );
}

export default function Cajas() {
  const [cajas,      setCajas]      = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [err,        setErr]        = useState("");
  const [historialCaja, setHistorialCaja] = useState(null);
  const [vaciarCaja,    setVaciarCaja]    = useState(null);
  const [ajusteCaja,    setAjusteCaja]    = useState(null);
  const [filtro,    setFiltro]    = useState("todas");
  const [busqueda,  setBusqueda]  = useState("");
  const [sort, setSort] = useState({ col: "caja", dir: "asc" });

  const load = () => {
    setLoading(true); setErr("");
    fetch("/api/cajas").then(r => r.json()).then(setCajas)
      .catch(e => setErr(String(e?.message || e))).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const onSort = (col) => setSort(prev => prev.col === col ? { col, dir: prev.dir === "asc" ? "desc" : "asc" } : { col, dir: "desc" });

  const cajasFiltradas = useMemo(() => {
    const q = busqueda.trim().toLowerCase();
    const filtered = cajas.filter(c => {
      if (filtro !== "todas" && c.cajaTipo !== filtro) return false;
      if (!q) return true;
      const names = c.members.map(m => `${m.displayName||""} ${m.lastKnownUniqueId||""} ${m.cajaLabel||""}`.toLowerCase()).join(" ");
      return String(c.caja).includes(q) || names.includes(q);
    });
    return [...filtered].sort((a, b) => {
      let av, bv;
      switch (sort.col) {
        case "caja":       av = a.caja; bv = b.caja; break;
        case "cajaTipo":   av = a.cajaTipo||""; bv = b.cajaTipo||""; break;
        case "displayName":av = a.displayName.toLowerCase(); bv = b.displayName.toLowerCase(); break;
        case "count":      av = a.count; bv = b.count; break;
        case "totalAmount":av = a.totalAmount; bv = b.totalAmount; break;
        default: av = 0; bv = 0;
      }
      return av < bv ? (sort.dir === "asc" ? -1 : 1) : av > bv ? (sort.dir === "asc" ? 1 : -1) : 0;
    });
  }, [cajas, filtro, sort, busqueda]);

  const totalPendiente = cajasFiltradas.reduce((s, c) => s + Number(c.totalAmount || 0), 0);
  const totalCompras   = cajasFiltradas.reduce((s, c) => s + Number(c.count || 0), 0);
  const sortProps = { sort, onSort };

  return (
    <div className="card" style={{ maxWidth: 1050 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
        <h2 className="cardTitle" style={{ margin: 0 }}>Gestión de cajas</h2>
        <button className="btn btn-outline" onClick={load} disabled={loading} style={{ marginLeft: "auto" }}>
          {loading ? "Cargando…" : "↻ Refrescar"}
        </button>
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
        <input className="input" value={busqueda} onChange={e => setBusqueda(e.target.value)}
          placeholder="🔍 Buscar por nº caja o nombre…" style={{ flex: 1, minWidth: 200 }} />
        {busqueda && <button className="btn btn-outline" onClick={() => setBusqueda("")}>✕</button>}
        {["todas", "enviar", "recoger"].map(f => (
          <button key={f} className={filtro === f ? "btn btn-primary" : "btn btn-outline"}
            onClick={() => setFiltro(f)} style={{ textTransform: "capitalize" }}>{f}</button>
        ))}
      </div>

      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
        {[
          { label: "Cajas", value: cajasFiltradas.length },
          { label: "Compras pendientes", value: totalCompras },
          { label: "Total pendiente", value: fmt(totalPendiente), red: true },
        ].map(s => (
          <div key={s.label} style={{ flex: 1, minWidth: 130, padding: "12px 16px", border: `1px solid ${s.red ? "var(--brand-red)" : "var(--border)"}`, borderRadius: 10, background: "#fff" }}>
            <div style={{ fontSize: 12, opacity: 0.6, marginBottom: 4 }}>{s.label}</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: s.red ? "var(--brand-red)" : "inherit" }}>{s.value}</div>
          </div>
        ))}
      </div>

      {err && <div style={{ padding: 10, background: "#fff5f5", border: "1px solid #f5c2c7", borderRadius: 8, marginBottom: 12, color: "crimson" }}>{err}</div>}

      {cajasFiltradas.length === 0 && !loading ? (
        <p style={{ opacity: 0.6 }}>No hay cajas con este filtro.</p>
      ) : (
        <div style={{ border: "1px solid var(--border)", borderRadius: 10, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f5f5f5" }}>
                <SortTh label="Caja"      col="caja"        {...sortProps} />
                <SortTh label="Tipo"      col="cajaTipo"    {...sortProps} />
                <SortTh label="Comprador" col="displayName" {...sortProps} />
                <SortTh label="Compras"   col="count"       {...sortProps} />
                <SortTh label="Acumulado" col="totalAmount" {...sortProps} />
                <th style={th}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {cajasFiltradas.map(c => (
                <tr key={c.caja} style={{ background: c.count > 0 ? "#fffbf0" : "#fff" }}>
                  <td style={{ ...td, fontWeight: 800, fontSize: 22 }}>{c.caja}</td>
                  <td style={td}>
                    <span style={{ display: "inline-block", padding: "2px 10px", borderRadius: 20, fontSize: 12, fontWeight: 700, background: c.cajaTipo === "enviar" ? "#e0f2fe" : "#f3e8ff", color: c.cajaTipo === "enviar" ? "#0369a1" : "#7c3aed" }}>
                      {c.cajaTipo || "—"}
                    </span>
                  </td>
                  <td style={td}>
                    {c.members.length > 1 ? (
                      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                        <div style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 8px", borderRadius: 99, background: "#fef3c7", fontSize: 11, fontWeight: 700, color: "#92400e", width: "fit-content" }}>
                          🔗 Fusionada · {c.members.length} compradores
                        </div>
                        {c.members.map(m => {
                          const bal = c.byUser?.find(u => u.userId === m.id);
                          return (
                            <div key={m.id} style={{ display: "flex", alignItems: "center", gap: 7 }}>
                              {m.profilePictureUrl && <img src={m.profilePictureUrl} alt="" style={{ width: 24, height: 24, borderRadius: "50%", objectFit: "cover" }} />}
                              <div style={{ flex: 1 }}>
                                <div style={{ fontWeight: 600, fontSize: 13 }}>{m.cajaLabel || m.displayName}</div>
                                {m.lastKnownUniqueId && <div style={{ fontSize: 11, opacity: 0.55 }}>@{m.lastKnownUniqueId}</div>}
                              </div>
                              {bal && <div style={{ fontSize: 12, fontWeight: 700, color: bal.amount > 0 ? "var(--brand-red)" : "#9ca3af" }}>{fmt(bal.amount)}</div>}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {c.members[0]?.profilePictureUrl && <img src={c.members[0].profilePictureUrl} alt="" style={{ width: 30, height: 30, borderRadius: "50%", objectFit: "cover" }} />}
                        <div>
                          <div style={{ fontWeight: 600 }}>{c.members[0]?.cajaLabel || c.displayName}</div>
                          {c.members[0]?.lastKnownUniqueId && <div style={{ fontSize: 12, opacity: 0.6 }}>@{c.members[0].lastKnownUniqueId}</div>}
                        </div>
                      </div>
                    )}
                  </td>
                  <td style={{ ...td, textAlign: "center" }}>
                    <span style={{ fontWeight: 700, fontSize: 18 }}>{c.count}</span>
                  </td>
                  <td style={td}>
                    <span style={{ fontWeight: 800, fontSize: 18, color: c.totalAmount > 0 ? "var(--brand-red)" : "inherit" }}>{fmt(c.totalAmount)}</span>
                  </td>
                  <td style={td}>
                    <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                      <button className="btn btn-primary" disabled={c.count === 0}
                        onClick={() => setVaciarCaja(c)} style={{ fontSize: 13, padding: "6px 12px" }}>
                        💳 Liquidar
                      </button>
                      <button className="btn btn-outline"
                        onClick={() => setAjusteCaja(c)} style={{ fontSize: 13, padding: "6px 12px" }}>
                        ⚙️ Ajuste
                      </button>
                      <button className="btn btn-outline"
                        onClick={() => setHistorialCaja(c.caja)} style={{ fontSize: 13, padding: "6px 12px" }}>
                        📋 Historial
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {vaciarCaja && <PopupVaciar caja={vaciarCaja} onClose={() => setVaciarCaja(null)} onDone={() => { setVaciarCaja(null); load(); }} />}
      {ajusteCaja  && <PopupAjuste  caja={ajusteCaja}  onClose={() => setAjusteCaja(null)}  onDone={() => { setAjusteCaja(null);  load(); }} />}
      {historialCaja !== null && <HistorialVaciados caja={historialCaja} onClose={() => setHistorialCaja(null)} />}
    </div>
  );
}

const th = { textAlign: "left", padding: "10px 12px", borderBottom: "1px solid #ddd", fontWeight: 600, fontSize: 13 };
const td = { padding: "10px 12px", borderBottom: "1px solid #eee", verticalAlign: "middle" };
